import { TaskPublicDtoRead } from '@/store/services/MidleNestApi.service';
import { useDispatch } from 'react-redux';
import { useAuthenticated } from './useAuthenticated.hook';
import { useProfile } from './useProfile.hook';
import { systemActions } from '@/store/features/system.slice';
import { useInit } from './useInit.hook';
import { Quests } from '@/types/quests.type';
import { useTask } from './useTask.hook';
import { MouseEvent, useCallback } from 'react';

interface IProps {
  setIsActive?: (isActive: boolean) => void;
  showTaskModal?: () => void;
  showSubmitModal?: () => void;
  task: TaskPublicDtoRead;
  refresh?: boolean;
}

export const useHandleCompleteTask = ({
  showTaskModal,
  showSubmitModal,
  setIsActive,
  task,
  refresh = true,
}: IProps) => {
  if (event) {
    event.stopPropagation();
  }
  const { isAuthenticated } = useAuthenticated();
  const {
    profile: { user },
  } = useProfile();
  const dispatch = useDispatch();
  const { getProviderTitle } = useInit();
  const { complete } = useTask(String(task.id));

  return useCallback(
    (event?: MouseEvent<HTMLElement>) => {
      if (event) {
        event.stopPropagation();
      }
      if (!isAuthenticated && showTaskModal) {
        showTaskModal();
        return;
      }

      const taskProvider = user?.accounts.filter(
        (account) => account.provider === task.provider && account.isVerified,
      );
      // TODO: Visit link olarak calistirilmak istenen actionlar burasi editlenmeden cozulebilmeli

      if (['gitcoinScore', 'customCheckPostWeb3'].includes(task.action)) {
        if (!user?.accounts?.some((account) => account.provider === 'wallet')) {
          // here
          dispatch(
            systemActions.pushMessage({
              message: 'Connect your wallet first!',
              link: '/settings/connect',
              linkText: 'Check you connected accounts',
            }),
          );
        }
      }
      if (
        task.provider !== 'midle' &&
        taskProvider.length == 0 &&
        ![
          'customCheck',
          'customCheckPost',
          'customCheckPostWeb3',
          'visitLink',
          'facebookViewPage',
          'instagramViewPost',
          'instagramVisitProfile',
          'instagramCommentPost',
          'instagramLikePost',
          'instagramFollow',
          'youtubeLike',
          'youtubeSubscribe',
          'gitcoinScore',
        ].includes(task.action)
      ) {
        // here
        dispatch(
          systemActions.pushMessage({
            message: `Connect your ${getProviderTitle(task?.provider || 'account')} first!`,
            link: '/settings/connect',
            linkText: 'Check you connected accounts',
          }),
        );
      } else {
        const actionType = task.action as Quests;
        if (
          [
            'uploadScreenShot',
            'facebookViewPage',
            'instagramViewPost',
            'instagramVisitProfile',
            'instagramCommentPost',
            'instagramLikePost',
            'instagramFollow',
            'youtubeLike',
            'youtubeSubscribe',
          ].includes(task.action) &&
          showSubmitModal
        ) {
          showSubmitModal();
          // if (!complete[actionType]) throw `${actionType} has not defined!`;
        } else {
          complete(actionType)({
            title: task.title,
            action: task.action,
            data: task.data,
            visitUrl: task.visitUrl,
            description: task.description,
            xp: task.xp,
            id: task.id,
          } as TaskPublicDtoRead);

          if (refresh) {
            window.location.reload();
          }
        }

        if (setIsActive) {
          setIsActive(false);
          setTimeout(() => setIsActive(true), 5000);
        }
      }
      // TASK CLICK
      if (user.id)
        gtag('event', 'task-click', {
          task: task.id,
          user: user?.id,
          project: task.customer.id,
          platform: task.platform,
          action: task.action,
        });
    },
    [user, task, complete, showTaskModal, showSubmitModal],
  );
};
// const handleComplete = useCallback(
//   [user, action, props, complete, id, xp, showModal, submitShowModal, customer, platform],
// );
